import { CallButton } from "@/components/CallButton";

export const MobileCallBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink/90 p-3 backdrop-blur-xl md:hidden"
    data-testid="mobile-call-bar"
  >
    <CallButton size="lg" showNumber className="w-full" testid="sticky-call-btn" />
  </div>
);
